import bffRequest from '../../../shared/requests/bffRequest';

const getNews = async (featureFlags) => {
  const response = await bffRequest({
    path: 'news',
    method: 'GET',
    query: {
      featureFlags,
    },
  });

  return { articles: response };
};

export default {
  getNews,
};
